var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2426 4.74263C10.4769 4.50832 10.8568 4.50832 11.0912 4.74263L14.4245 8.07596C14.6588 8.31028 14.6588 8.69018 14.4245 8.92449L11.0912 12.2578C10.8568 12.4921 10.4769 12.4921 10.2426 12.2578C10.0083 12.0235 10.0083 11.6436 10.2426 11.4093L13.1517 8.50023L10.2426 5.59116C10.0083 5.35684 10.0083 4.97695 10.2426 4.74263Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3999 8.4999C5.3999 8.16853 5.66853 7.8999 5.9999 7.8999H13.9999C14.3313 7.8999 14.5999 8.16853 14.5999 8.4999C14.5999 8.83127 14.3313 9.0999 13.9999 9.0999H5.9999C5.66853 9.0999 5.3999 8.83127 5.3999 8.4999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33324 3.0999C3.13874 3.0999 2.95222 3.17716 2.81469 3.31469C2.67716 3.45222 2.5999 3.63874 2.5999 3.83324V13.1666C2.5999 13.3611 2.67716 13.5476 2.81469 13.6851C2.95222 13.8226 3.13874 13.8999 3.33324 13.8999H5.9999C6.33127 13.8999 6.5999 14.1685 6.5999 14.4999C6.5999 14.8313 6.33127 15.0999 5.9999 15.0999H3.33324C2.82048 15.0999 2.32873 14.8962 1.96616 14.5336C1.60359 14.1711 1.3999 13.6793 1.3999 13.1666V3.83324C1.3999 3.32048 1.60359 2.82873 1.96616 2.46616C2.32873 2.10359 2.82048 1.8999 3.33324 1.8999H5.9999C6.33127 1.8999 6.5999 2.16853 6.5999 2.4999C6.5999 2.83127 6.33127 3.0999 5.9999 3.0999H3.33324Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.20d0b6cf0fa610d70b28a69476b70727.svg";
export { ForwardRef as ReactComponent };